<template>
    <div class="container">
        <page-parts :items="items"/>
    </div>
</template>

<script>
export default {
    name: "SimpleContainerContentWrapper",
    props: ['items'],
}
</script>

<style lang="sass" scoped>
@import "sass/components/pages/wrappers/SimpleContainerContentWrapper"
</style>